import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { URI } from './uri.js';
import { compareSubstringIgnoreCase, compare, compareSubstring } from './strings.js';
import { Schemas } from './network.js';
import { isLinux } from './platform.js';
export var StringIterator = /*#__PURE__*/function () {
  function StringIterator() {
    _classCallCheck(this, StringIterator);

    this._value = '';
    this._pos = 0;
  }

  _createClass(StringIterator, [{
    key: "reset",
    value: function reset(key) {
      this._value = key;
      this._pos = 0;
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      this._pos += 1;
      return this;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this._pos < this._value.length - 1;
    }
  }, {
    key: "cmp",
    value: function cmp(a) {
      var aCode = a.charCodeAt(0);

      var thisCode = this._value.charCodeAt(this._pos);

      return aCode - thisCode;
    }
  }, {
    key: "value",
    value: function value() {
      return this._value[this._pos];
    }
  }]);

  return StringIterator;
}();
export var PathIterator = /*#__PURE__*/function () {
  function PathIterator() {
    var _splitOnBackslash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var _caseSensitive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, PathIterator);

    this._splitOnBackslash = _splitOnBackslash;
    this._caseSensitive = _caseSensitive;
  }

  _createClass(PathIterator, [{
    key: "reset",
    value: function reset(key) {
      this._value = key.replace(/\\$|\/$/, '');
      this._from = 0;
      this._to = 0;
      return this.next();
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this._to < this._value.length;
    }
  }, {
    key: "next",
    value: function next() {
      // this._data = key.split(/[\\/]/).filter(s => !!s);
      this._from = this._to;
      var justSeps = true;

      for (; this._to < this._value.length; this._to++) {
        var ch = this._value.charCodeAt(this._to);

        if (ch === 47
        /* Slash */
        || this._splitOnBackslash && ch === 92
        /* Backslash */
        ) {
          if (justSeps) {
            this._from++;
          } else {
            break;
          }
        } else {
          justSeps = false;
        }
      }

      return this;
    }
  }, {
    key: "cmp",
    value: function cmp(a) {
      return this._caseSensitive ? compareSubstring(a, this._value, 0, a.length, this._from, this._to) : compareSubstringIgnoreCase(a, this._value, 0, a.length, this._from, this._to);
    }
  }, {
    key: "value",
    value: function value() {
      return this._value.substring(this._from, this._to);
    }
  }]);

  return PathIterator;
}();
export var UriIterator = /*#__PURE__*/function () {
  function UriIterator() {
    _classCallCheck(this, UriIterator);

    this._states = [];
    this._stateIdx = 0;
  }

  _createClass(UriIterator, [{
    key: "reset",
    value: function reset(key) {
      this._value = key;
      this._states = [];

      if (this._value.scheme) {
        this._states.push(1
        /* Scheme */
        );
      }

      if (this._value.authority) {
        this._states.push(2
        /* Authority */
        );
      }

      if (this._value.path) {
        //todo@jrieken the case-sensitive logic is copied form `resources.ts#hasToIgnoreCase`
        // which cannot be used because it depends on this
        var caseSensitive = key.scheme === Schemas.file && isLinux;
        this._pathIterator = new PathIterator(false, caseSensitive);

        this._pathIterator.reset(key.path);

        if (this._pathIterator.value()) {
          this._states.push(3
          /* Path */
          );
        }
      }

      if (this._value.query) {
        this._states.push(4
        /* Query */
        );
      }

      if (this._value.fragment) {
        this._states.push(5
        /* Fragment */
        );
      }

      this._stateIdx = 0;
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      if (this._states[this._stateIdx] === 3
      /* Path */
      && this._pathIterator.hasNext()) {
        this._pathIterator.next();
      } else {
        this._stateIdx += 1;
      }

      return this;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this._states[this._stateIdx] === 3
      /* Path */
      && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
    }
  }, {
    key: "cmp",
    value: function cmp(a) {
      if (this._states[this._stateIdx] === 1
      /* Scheme */
      ) {
        return compare(a, this._value.scheme);
      } else if (this._states[this._stateIdx] === 2
      /* Authority */
      ) {
        return compareSubstringIgnoreCase(a, this._value.authority);
      } else if (this._states[this._stateIdx] === 3
      /* Path */
      ) {
        return this._pathIterator.cmp(a);
      } else if (this._states[this._stateIdx] === 4
      /* Query */
      ) {
        return compare(a, this._value.query);
      } else if (this._states[this._stateIdx] === 5
      /* Fragment */
      ) {
        return compare(a, this._value.fragment);
      }

      throw new Error();
    }
  }, {
    key: "value",
    value: function value() {
      if (this._states[this._stateIdx] === 1
      /* Scheme */
      ) {
        return this._value.scheme;
      } else if (this._states[this._stateIdx] === 2
      /* Authority */
      ) {
        return this._value.authority;
      } else if (this._states[this._stateIdx] === 3
      /* Path */
      ) {
        return this._pathIterator.value();
      } else if (this._states[this._stateIdx] === 4
      /* Query */
      ) {
        return this._value.query;
      } else if (this._states[this._stateIdx] === 5
      /* Fragment */
      ) {
        return this._value.fragment;
      }

      throw new Error();
    }
  }]);

  return UriIterator;
}();

var TernarySearchTreeNode = function TernarySearchTreeNode() {
  _classCallCheck(this, TernarySearchTreeNode);
};

export var TernarySearchTree = /*#__PURE__*/function () {
  function TernarySearchTree(segments) {
    _classCallCheck(this, TernarySearchTree);

    this._iter = segments;
  }

  _createClass(TernarySearchTree, [{
    key: "clear",
    value: function clear() {
      this._root = undefined;
    }
  }, {
    key: "set",
    value: function set(key, element) {
      var iter = this._iter.reset(key);

      var node;

      if (!this._root) {
        this._root = new TernarySearchTreeNode();
        this._root.segment = iter.value();
      }

      node = this._root;

      while (true) {
        var val = iter.cmp(node.segment);

        if (val > 0) {
          // left
          if (!node.left) {
            node.left = new TernarySearchTreeNode();
            node.left.segment = iter.value();
          }

          node = node.left;
        } else if (val < 0) {
          // right
          if (!node.right) {
            node.right = new TernarySearchTreeNode();
            node.right.segment = iter.value();
          }

          node = node.right;
        } else if (iter.hasNext()) {
          // mid
          iter.next();

          if (!node.mid) {
            node.mid = new TernarySearchTreeNode();
            node.mid.segment = iter.value();
          }

          node = node.mid;
        } else {
          break;
        }
      }

      var oldElement = node.value;
      node.value = element;
      node.key = key;
      return oldElement;
    }
  }, {
    key: "get",
    value: function get(key) {
      var iter = this._iter.reset(key);

      var node = this._root;

      while (node) {
        var val = iter.cmp(node.segment);

        if (val > 0) {
          // left
          node = node.left;
        } else if (val < 0) {
          // right
          node = node.right;
        } else if (iter.hasNext()) {
          // mid
          iter.next();
          node = node.mid;
        } else {
          break;
        }
      }

      return node ? node.value : undefined;
    }
  }, {
    key: "findSubstr",
    value: function findSubstr(key) {
      var iter = this._iter.reset(key);

      var node = this._root;
      var candidate = undefined;

      while (node) {
        var val = iter.cmp(node.segment);

        if (val > 0) {
          // left
          node = node.left;
        } else if (val < 0) {
          // right
          node = node.right;
        } else if (iter.hasNext()) {
          // mid
          iter.next();
          candidate = node.value || candidate;
          node = node.mid;
        } else {
          break;
        }
      }

      return node && node.value || candidate;
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      this._forEach(this._root, callback);
    }
  }, {
    key: "_forEach",
    value: function _forEach(node, callback) {
      if (node) {
        // left
        this._forEach(node.left, callback); // node


        if (node.value) {
          // callback(node.value, this._iter.join(parts));
          callback(node.value, node.key);
        } // mid


        this._forEach(node.mid, callback); // right


        this._forEach(node.right, callback);
      }
    }
  }], [{
    key: "forUris",
    value: function forUris() {
      return new TernarySearchTree(new UriIterator());
    }
  }, {
    key: "forStrings",
    value: function forStrings() {
      return new TernarySearchTree(new StringIterator());
    }
  }]);

  return TernarySearchTree;
}();
export var ResourceMap = /*#__PURE__*/function (_Symbol$iterator) {
  function ResourceMap(mapOrKeyFn, toKey) {
    _classCallCheck(this, ResourceMap);

    this[Symbol.toStringTag] = 'ResourceMap';

    if (mapOrKeyFn instanceof ResourceMap) {
      this.map = new Map(mapOrKeyFn.map);
      this.toKey = toKey !== null && toKey !== void 0 ? toKey : ResourceMap.defaultToKey;
    } else {
      this.map = new Map();
      this.toKey = mapOrKeyFn !== null && mapOrKeyFn !== void 0 ? mapOrKeyFn : ResourceMap.defaultToKey;
    }
  }

  _createClass(ResourceMap, [{
    key: "set",
    value: function set(resource, value) {
      this.map.set(this.toKey(resource), value);
      return this;
    }
  }, {
    key: "get",
    value: function get(resource) {
      return this.map.get(this.toKey(resource));
    }
  }, {
    key: "has",
    value: function has(resource) {
      return this.map.has(this.toKey(resource));
    }
  }, {
    key: "size",
    get: function get() {
      return this.map.size;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: "delete",
    value: function _delete(resource) {
      return this.map.delete(this.toKey(resource));
    }
  }, {
    key: "forEach",
    value: function forEach(clb, thisArg) {
      if (typeof thisArg !== 'undefined') {
        clb = clb.bind(thisArg);
      }

      var _iterator = _createForOfIteratorHelper(this.map),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              index = _step$value[0],
              value = _step$value[1];

          clb(value, URI.parse(index), this);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "values",
    value: function values() {
      return this.map.values();
    }
  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var _iterator2, _step2, key;

      return _regeneratorRuntime.wrap(function keys$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.map.keys());
              _context.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 9;
                break;
              }

              key = _step2.value;
              _context.next = 7;
              return URI.parse(key);

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator2.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator2.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, keys, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var _iterator3, _step3, tuple;

      return _regeneratorRuntime.wrap(function entries$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this.map.entries());
              _context2.prev = 1;

              _iterator3.s();

            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context2.next = 9;
                break;
              }

              tuple = _step3.value;
              _context2.next = 7;
              return [URI.parse(tuple[0]), tuple[1]];

            case 7:
              _context2.next = 3;
              break;

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);

              _iterator3.e(_context2.t0);

            case 14:
              _context2.prev = 14;

              _iterator3.f();

              return _context2.finish(14);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, entries, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var _iterator4, _step4, item;

      return _regeneratorRuntime.wrap(function value$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this.map);
              _context3.prev = 1;

              _iterator4.s();

            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context3.next = 9;
                break;
              }

              item = _step4.value;
              _context3.next = 7;
              return [URI.parse(item[0]), item[1]];

            case 7:
              _context3.next = 3;
              break;

            case 9:
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);

              _iterator4.e(_context3.t0);

            case 14:
              _context3.prev = 14;

              _iterator4.f();

              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, value, this, [[1, 11, 14, 17]]);
    })
  }]);

  return ResourceMap;
}(Symbol.iterator);

ResourceMap.defaultToKey = function (resource) {
  return resource.toString();
};

export var LinkedMap = /*#__PURE__*/function (_Symbol$iterator2) {
  function LinkedMap() {
    _classCallCheck(this, LinkedMap);

    this[Symbol.toStringTag] = 'LinkedMap';
    this._map = new Map();
    this._head = undefined;
    this._tail = undefined;
    this._size = 0;
    this._state = 0;
  }

  _createClass(LinkedMap, [{
    key: "clear",
    value: function clear() {
      this._map.clear();

      this._head = undefined;
      this._tail = undefined;
      this._size = 0;
      this._state++;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this._head && !this._tail;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "first",
    get: function get() {
      var _a;

      return (_a = this._head) === null || _a === void 0 ? void 0 : _a.value;
    }
  }, {
    key: "last",
    get: function get() {
      var _a;

      return (_a = this._tail) === null || _a === void 0 ? void 0 : _a.value;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this._map.has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var item = this._map.get(key);

      if (!item) {
        return undefined;
      }

      if (touch !== 0
      /* None */
      ) {
        this.touch(item, touch);
      }

      return item.value;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var touch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var item = this._map.get(key);

      if (item) {
        item.value = value;

        if (touch !== 0
        /* None */
        ) {
          this.touch(item, touch);
        }
      } else {
        item = {
          key: key,
          value: value,
          next: undefined,
          previous: undefined
        };

        switch (touch) {
          case 0
          /* None */
          :
            this.addItemLast(item);
            break;

          case 1
          /* AsOld */
          :
            this.addItemFirst(item);
            break;

          case 2
          /* AsNew */
          :
            this.addItemLast(item);
            break;

          default:
            this.addItemLast(item);
            break;
        }

        this._map.set(key, item);

        this._size++;
      }

      return this;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return !!this.remove(key);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var item = this._map.get(key);

      if (!item) {
        return undefined;
      }

      this._map.delete(key);

      this.removeItem(item);
      this._size--;
      return item.value;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this._head && !this._tail) {
        return undefined;
      }

      if (!this._head || !this._tail) {
        throw new Error('Invalid list');
      }

      var item = this._head;

      this._map.delete(item.key);

      this.removeItem(item);
      this._size--;
      return item.value;
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn, thisArg) {
      var state = this._state;
      var current = this._head;

      while (current) {
        if (thisArg) {
          callbackfn.bind(thisArg)(current.value, current.key, this);
        } else {
          callbackfn(current.value, current.key, this);
        }

        if (this._state !== state) {
          throw new Error("LinkedMap got modified during iteration.");
        }

        current = current.next;
      }
    }
  }, {
    key: "keys",
    value: function keys() {
      var _iterator5;

      var map = this;
      var state = this._state;
      var current = this._head;
      var iterator = (_iterator5 = {}, _defineProperty(_iterator5, Symbol.iterator, function () {
        return iterator;
      }), _defineProperty(_iterator5, "next", function next() {
        if (map._state !== state) {
          throw new Error("LinkedMap got modified during iteration.");
        }

        if (current) {
          var result = {
            value: current.key,
            done: false
          };
          current = current.next;
          return result;
        } else {
          return {
            value: undefined,
            done: true
          };
        }
      }), _iterator5);
      return iterator;
    }
  }, {
    key: "values",
    value: function values() {
      var _iterator6;

      var map = this;
      var state = this._state;
      var current = this._head;
      var iterator = (_iterator6 = {}, _defineProperty(_iterator6, Symbol.iterator, function () {
        return iterator;
      }), _defineProperty(_iterator6, "next", function next() {
        if (map._state !== state) {
          throw new Error("LinkedMap got modified during iteration.");
        }

        if (current) {
          var result = {
            value: current.value,
            done: false
          };
          current = current.next;
          return result;
        } else {
          return {
            value: undefined,
            done: true
          };
        }
      }), _iterator6);
      return iterator;
    }
  }, {
    key: "entries",
    value: function entries() {
      var _iterator7;

      var map = this;
      var state = this._state;
      var current = this._head;
      var iterator = (_iterator7 = {}, _defineProperty(_iterator7, Symbol.iterator, function () {
        return iterator;
      }), _defineProperty(_iterator7, "next", function next() {
        if (map._state !== state) {
          throw new Error("LinkedMap got modified during iteration.");
        }

        if (current) {
          var result = {
            value: [current.key, current.value],
            done: false
          };
          current = current.next;
          return result;
        } else {
          return {
            value: undefined,
            done: true
          };
        }
      }), _iterator7);
      return iterator;
    }
  }, {
    key: _Symbol$iterator2,
    value: function value() {
      return this.entries();
    }
  }, {
    key: "trimOld",
    value: function trimOld(newSize) {
      if (newSize >= this.size) {
        return;
      }

      if (newSize === 0) {
        this.clear();
        return;
      }

      var current = this._head;
      var currentSize = this.size;

      while (current && currentSize > newSize) {
        this._map.delete(current.key);

        current = current.next;
        currentSize--;
      }

      this._head = current;
      this._size = currentSize;

      if (current) {
        current.previous = undefined;
      }

      this._state++;
    }
  }, {
    key: "addItemFirst",
    value: function addItemFirst(item) {
      // First time Insert
      if (!this._head && !this._tail) {
        this._tail = item;
      } else if (!this._head) {
        throw new Error('Invalid list');
      } else {
        item.next = this._head;
        this._head.previous = item;
      }

      this._head = item;
      this._state++;
    }
  }, {
    key: "addItemLast",
    value: function addItemLast(item) {
      // First time Insert
      if (!this._head && !this._tail) {
        this._head = item;
      } else if (!this._tail) {
        throw new Error('Invalid list');
      } else {
        item.previous = this._tail;
        this._tail.next = item;
      }

      this._tail = item;
      this._state++;
    }
  }, {
    key: "removeItem",
    value: function removeItem(item) {
      if (item === this._head && item === this._tail) {
        this._head = undefined;
        this._tail = undefined;
      } else if (item === this._head) {
        // This can only happend if size === 1 which is handle
        // by the case above.
        if (!item.next) {
          throw new Error('Invalid list');
        }

        item.next.previous = undefined;
        this._head = item.next;
      } else if (item === this._tail) {
        // This can only happend if size === 1 which is handle
        // by the case above.
        if (!item.previous) {
          throw new Error('Invalid list');
        }

        item.previous.next = undefined;
        this._tail = item.previous;
      } else {
        var next = item.next;
        var previous = item.previous;

        if (!next || !previous) {
          throw new Error('Invalid list');
        }

        next.previous = previous;
        previous.next = next;
      }

      item.next = undefined;
      item.previous = undefined;
      this._state++;
    }
  }, {
    key: "touch",
    value: function touch(item, _touch) {
      if (!this._head || !this._tail) {
        throw new Error('Invalid list');
      }

      if (_touch !== 1
      /* AsOld */
      && _touch !== 2
      /* AsNew */
      ) {
        return;
      }

      if (_touch === 1
      /* AsOld */
      ) {
        if (item === this._head) {
          return;
        }

        var next = item.next;
        var previous = item.previous; // Unlink the item

        if (item === this._tail) {
          // previous must be defined since item was not head but is tail
          // So there are more than on item in the map
          previous.next = undefined;
          this._tail = previous;
        } else {
          // Both next and previous are not undefined since item was neither head nor tail.
          next.previous = previous;
          previous.next = next;
        } // Insert the node at head


        item.previous = undefined;
        item.next = this._head;
        this._head.previous = item;
        this._head = item;
        this._state++;
      } else if (_touch === 2
      /* AsNew */
      ) {
        if (item === this._tail) {
          return;
        }

        var _next = item.next;
        var _previous = item.previous; // Unlink the item.

        if (item === this._head) {
          // next must be defined since item was not tail but is head
          // So there are more than on item in the map
          _next.previous = undefined;
          this._head = _next;
        } else {
          // Both next and previous are not undefined since item was neither head nor tail.
          _next.previous = _previous;
          _previous.next = _next;
        }

        item.next = undefined;
        item.previous = this._tail;
        this._tail.next = item;
        this._tail = item;
        this._state++;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = [];
      this.forEach(function (value, key) {
        data.push([key, value]);
      });
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(data) {
      this.clear();

      var _iterator8 = _createForOfIteratorHelper(data),
          _step5;

      try {
        for (_iterator8.s(); !(_step5 = _iterator8.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              key = _step5$value[0],
              _value = _step5$value[1];

          this.set(key, _value);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }]);

  return LinkedMap;
}(Symbol.iterator);
export var LRUCache = /*#__PURE__*/function (_LinkedMap) {
  _inherits(LRUCache, _LinkedMap);

  var _super = _createSuper(LRUCache);

  function LRUCache(limit) {
    var _this;

    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, LRUCache);

    _this = _super.call(this);
    _this._limit = limit;
    _this._ratio = Math.min(Math.max(0, ratio), 1);
    return _this;
  }

  _createClass(LRUCache, [{
    key: "limit",
    get: function get() {
      return this._limit;
    },
    set: function set(limit) {
      this._limit = limit;
      this.checkTrim();
    }
  }, {
    key: "get",
    value: function get(key) {
      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return _get(_getPrototypeOf(LRUCache.prototype), "get", this).call(this, key, touch);
    }
  }, {
    key: "peek",
    value: function peek(key) {
      return _get(_getPrototypeOf(LRUCache.prototype), "get", this).call(this, key, 0
      /* None */
      );
    }
  }, {
    key: "set",
    value: function set(key, value) {
      _get(_getPrototypeOf(LRUCache.prototype), "set", this).call(this, key, value, 2
      /* AsNew */
      );

      this.checkTrim();
      return this;
    }
  }, {
    key: "checkTrim",
    value: function checkTrim() {
      if (this.size > this._limit) {
        this.trimOld(Math.round(this._limit * this._ratio));
      }
    }
  }]);

  return LRUCache;
}(LinkedMap);